// Transforms validation errors to human readable messages

import { inject, Pipe, PipeTransform } from "@angular/core";
import { ServerError } from "@ramudden/models/error";
import { ErrorService } from "@ramudden/services";

@Pipe({
    name: "serverErrorMessage",
})
export class ServerErrorMessagePipe implements PipeTransform {
    private readonly errorService = inject(ErrorService);

    async transform(
        serverError: ServerError,
        fallbackMessage: string,
        _lang = "forceRefreshPipeTrick",
    ): Promise<string> {
        if (!serverError && !fallbackMessage) {
            return "";
        }

        if (serverError) {
            return this.errorService.getErrorString({ error: serverError });
        }

        return fallbackMessage;
    }
}
